import { buildCssClassName, getLinkDecorationTwClasses, getTransitionTwClasses } from "@/3514/utils"

const styles = {
    container: ({
        isDragging,
        isError,
        isLoaded
    }: {
        isDragging: boolean
        isError: boolean
        isLoaded: boolean
    }): string =>
        buildCssClassName(
            [
                "flex",
                "flex-col",
                "justify-center",
                "h-[200px]",
                "gap-y-[10px]",
                "w-full",
                "px-[15px]",
                "md:px-0",
                "border-dashed",
                "border-[1px]",
                "border-blue-300",
                "rounded-[10px]"
            ],
            isDragging ? "bg-blue-600" : "bg-white",
            isError ? "pt-[30px] pb-[10px]" : [isLoaded ? "pt-[20px] pb-[10px]" : "py-[30px]"],
            getTransitionTwClasses("all", 200)
        ),
    dropZone: (): string => "flex flex-col items-center justify-center gap-y-[15px]",
    input: (): string => "hidden h-full w-full",
    content: (): string => "flex flex-col items-center gap-y-[10px]",
    cropperContainer: (): string => "relative h-[140px] w-[140px]",
    cropperArea: (): string =>
        "!text-[rgba(0,0,0,0.2)] !border-transparent opacity-70 ![box-shadow:0_0_0_9999em_lightgray]",
    dragContainer: (): string => "w-[100px] h-[100px] rounded-full bg-blue-500 flex items-center justify-center",
    icon: (): string => "flex items-center justify-center",
    actionText: (): string => "text-gray-200 font-[400] font-serifDisplay text-[16px] leading-[24px]",
    zoomControls: (): string => "flex items-center justify-center gap-x-[3px] px-[10px]",
    zoomControl: (): string => "translate-y-[-1px]",
    zoomButton: (): string => "px-[3px]",
    zoomSlider: (): string =>
        buildCssClassName(
            "w-full",
            "h-[1px]",
            "appearance-none",
            "bg-blue-200",
            "rounded-full",
            "outline-none",
            "cursor-pointer",
            "[&::-webkit-slider-thumb]:appearance-none",
            "[&::-webkit-slider-thumb]:w-[15px]",
            "[&::-webkit-slider-thumb]:h-[15px]",
            "[&::-webkit-slider-thumb]:rounded-full",
            "[&::-webkit-slider-thumb]:bg-blue-200",
            "[&::-webkit-slider-thumb]:shadow-[0_0_0_3px_white]",
            "[&::-webkit-slider-thumb]:border-0",
            "[&::-webkit-slider-thumb]:cursor-pointer",
            "[&::-webkit-slider-runnable-track]:bg-transparent",
            "[&::-moz-range-thumb]:w-[15px]",
            "[&::-moz-range-thumb]:h-[15px]",
            "[&::-moz-range-thumb]:rounded-full",
            "[&::-moz-range-thumb]:bg-blue-200",
            "[&::-moz-range-thumb]:shadow-[0_0_0_3px_white]",
            "[&::-moz-range-thumb]:border-0",
            "[&::-moz-range-thumb]:cursor-pointer",
            "[&::-moz-range-track]:bg-transparent",
            "[&::-moz-range-track]:border-0"
        ),
    actionTextStrong: (): string =>
        buildCssClassName(
            "text-accent",
            "cursor-pointer",
            "!font-[400]",
            getLinkDecorationTwClasses({ color: "accent", offset: 3 })
        )
}

export { styles as imageUploadStyles }
